
// The parent module may be served from the CDN; workers must use the document origin.
const __githubUiWorker = {
  url: url => new URL(url.pathname + url.search + url.hash, self.location.origin).href,
}
export default __githubUiWorker.url(new URL("./socket.worker.ts?worker-entry", import.meta.url))
